import { DEFAULT_TOOLBAR_MOUSE_ENTER_DELAY } from "@org-avp/avp-avengers-ui-shared-utils";
import { Button, ButtonProps, Tooltip, TooltipProps } from "antd";
import { TFunction } from "i18next";
import { FC, UIEvent, useCallback, useMemo } from "react";
import { ContextAction } from "./context-action";
import { getFirstString, getShortcutText, optT } from "./util";

// toolbar button
export type ActionToolbarButtonProps = ButtonProps & {
  action: ContextAction;
  t: TFunction;
  tooltipPlacement?: TooltipProps["placement"];
  mouseEnterDelay?: TooltipProps["mouseEnterDelay"];
};

export const ActionToolbarButton: FC<ActionToolbarButtonProps> = (
  { action: { action, disabled, icon, shortcut, text, textKey, tooltip, tooltipKey }, t, tooltipPlacement, ...props }: ActionToolbarButtonProps,
) => {
  const onClick = useCallback(
    (e: UIEvent) => {
      e.stopPropagation();
      action();
    },
    [action],
  );

  const tooltipTitle = useMemo(
    () => {
      const tooltipText = getFirstString(tooltip, optT(t, tooltipKey), text, t(textKey));
      const shortcutText = shortcut ? getShortcutText(shortcut) : undefined;
      return (shortcutText ? `${tooltipText} (${shortcutText})` : tooltipText);
    },
    [shortcut, t, text, textKey, tooltip, tooltipKey],
  );
  const mouseEnterDelay = useMemo(() => {
    const delay = props.mouseEnterDelay;
    return delay !== undefined ? delay : DEFAULT_TOOLBAR_MOUSE_ENTER_DELAY;
  }, [props.mouseEnterDelay]);

  return (
    <Tooltip title={tooltipTitle} placement={tooltipPlacement} mouseEnterDelay={mouseEnterDelay}>
      <Button disabled={disabled} icon={icon} onClick={onClick} {...props}/>
    </Tooltip>
  );
};
